import 'babel-polyfill'
import Vue from 'vue'
import Router from 'vue-router'
import './utils/vueExtend'
import App from './App'
import routes from './router/routes'
import '@/components';
import store from '@/store'
import util from 'libs/util'
import 'styles/app.less'

import { InfiniteScroll } from 'element-ui';
Vue.use(InfiniteScroll)

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes
})


const token = util.getParam("token"); //从车集邦小程序
if (token) {
  util.setStorage("LLSS_TOKEN", token);
}

window.$router = router


Vue.config.productionTip = false


const routesMap = {}
const keepMaps = {}
routes.forEach((item) => {
  routesMap[item.name] = item;
})


const setNavActived = (to, navActiveIndex) => {
  if (!to.meta) {
    to.meta = {}
  }
  if (navActiveIndex == undefined) {
    store.dispatch('setNavActiveIndex', -1);
  } else {
    store.dispatch('setNavActiveIndex', navActiveIndex);
  }
}

const setRouteViewKeep = (to, from) => {
  const meta = to.meta || {}
  const keepName = meta.keepName
  const fromName = meta.fromName
  const query = to.query;
  if (!to.meta) {
    to.meta = {}
  }
  if (meta) {
    const title = meta && meta.title;
    document.title = title || ''
  }
  if (keepName && to.name === keepName && (fromName.indexOf(from.name) >= 0 || !keepMaps[keepName])) {
    to.meta.keepAlive = true;
    keepMaps[keepName] = 1
  } else {
    to.meta.keepAlive = false;
  }
}


const setBodyColor = (meta) => {
  if (meta.bgColor) {
    document.body.style.backgroundColor = '#fff'
  } else {
    document.body.style.backgroundColor = '#f6f6f6'
  }
}


Vue.prototype.$gopage = async function(pathName, query, isReplace) {
  const findItem = routesMap[pathName];
  let redirectType = isReplace ? 'replace' : 'push'
  if (util.getStorage('orgaId') && query) {
    query.orgaId = util.getStorage('orgaId')
  } else if (util.getStorage('orgaId') && !query){
    query = {orgaId: util.getStorage('orgaId')}
  }
  console.log(pathName, isReplace, '---------Vue.prototype.$gopage---------=-=--=',query);
  let path = '/';
  if (findItem) {
    path = findItem.path;
  } else {
    if (pathName.indexOf('/') >= 0) {
      path = pathName;
    }
  }
  router[redirectType]({
    path,
    query
  })
}

router.beforeEach((to, from, next) => {
  const meta = to.meta;
  const navIndex = meta.navIndex;
  setNavActived(to, navIndex);
  setRouteViewKeep(to, from);
  setBodyColor(meta);
  if (to.meta.auth) {
    user.checkIsLogin(() => {
      next();
    });
  } else {
    next()
  }
  console.log('-----------from',from)
  store.commit('setHistoryStack', {
    fullPath: to.fullPath, 
    curPath: from.fullPath
  });
})

Vue.prototype.$back = async function(url, query) {
  const $gopage = Vue.prototype.$gopage;
  if (url) {
    $gopage(url, {}, true)
  } else {
    router.back();
  }
}
store.dispatch('queryUserInfo');
store.dispatch('queryStatInfo');
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})